<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">标本管理</span>
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 标本管理</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:0px 0 0 20px">
          <el-main id="SampleManage">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(0)">
              <!--<el-form-item>-->
                <!--<el-input v-model="dataForm.orderNum" placeholder="订单号" clearable></el-input>-->
              <!--</el-form-item>-->
              <el-form-item>
                <el-input v-model="dataForm.hospCode" class="txmr" placeholder="医院条形码" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="dataForm.patientName" class="txmr" placeholder="姓名" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="dataForm.patientTel" class="txmr" placeholder="联系电话" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataForm.testStatus" class="mhide" placeholder="标本状态" clearable>
                  <el-option
                    v-for="item in options_status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="dataForm.providerName" class="mhide" placeholder="送检检验所" clearable></el-input>
                <!--<el-select v-model="dataForm.providerName" class="mhide" placeholder="送检检验所" filterable clearable @change="selectProvider($event)">-->
                  <!--<el-option-->
                    <!--v-for="(item,index) in options_provider"-->
                    <!--:key="item.id"-->
                    <!--:label="item.providerName"-->
                    <!--:value="item">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              </el-form-item>
              <el-form-item>
                <el-input v-model="dataForm.itemName" placeholder="检验项目" clearable></el-input>
                <!--<el-select v-model="dataForm.itemName" placeholder="检验项目" filterable clearable>-->
                  <!--<el-option-->
                    <!--v-for="item in options_item"-->
                    <!--:key="item.id"-->
                    <!--:label="item.itemName"-->
                    <!--:value="item.itemName">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              </el-form-item>
              <el-form-item>
                <el-select class="mhide" v-model="dataForm.result" placeholder="检验结果" clearable>
                  <el-option
                    v-for="item in options_result"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!--<el-form-item>-->
              <!--<el-date-picker-->
              <!--v-model="dataForm.orderAddBt"-->
              <!--type="datetime"-->
              <!--placeholder="订单创建起始时间"-->
              <!--value-format="yyyy-MM-dd HH:mm:ss"-->
              <!--:picker-options="picker_orderAddBt">-->
              <!--</el-date-picker>-->
              <!--</el-form-item>-->
              <!--<el-form-item>-->
              <!--<el-date-picker-->
              <!--v-model="dataForm.orderAddEt"-->
              <!--type="datetime"-->
              <!--placeholder="订单创建截止时间"-->
              <!--value-format="yyyy-MM-dd HH:mm:ss"-->
              <!--:picker-options="picker_orderAddEt">-->
              <!--</el-date-picker>-->
              <!--</el-form-item>-->
              <el-form-item class="mhide">
                <el-date-picker
                  v-model="dataForm.snReceiveBt"
                  type="datetime"
                  placeholder="收样起始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="picker_snReceiveBt">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="mhide">
                <el-date-picker
                  v-model="dataForm.snReceiveEt"
                  type="datetime"
                  placeholder="收样截止时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="picker_snReceiveEt">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="mhide">
                <el-date-picker
                  v-model="dataForm.reportBt"
                  type="datetime"
                  placeholder="报告起始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="picker_reportBt">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="mhide">
                <el-date-picker
                  v-model="dataForm.reportEt"
                  type="datetime"
                  placeholder="报告截止时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="picker_reportEt">
                </el-date-picker>
              </el-form-item>
              <br/>
              <el-form-item>
                <el-button @click="getDataList(0)">查询</el-button>
              </el-form-item>
              <template v-if="user.isChannel == 2">
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="downloadReport('')">
                    报告批量下载
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="exportExcel">导出标本</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click.native.prevent="addOrUpdateHandle()">
                    录入标本
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click.native.prevent="downloadTemplate()">
                    下载模板
                  </el-button>
                </el-form-item>
                <!--<el-form-item>-->
                  <!--<el-upload-->
                    <!--ref="upload"-->
                    <!--:action="importSampleUrl"-->
                    <!--:on-success="successHandle"-->
                    <!--:on-exceed="handleExceed"-->
                    <!--:before-upload="beforeUploadHandle"-->
                    <!--:show-file-list="false"-->
                    <!--:multiple="false"-->
                    <!--:limit="1"-->
                    <!--:file-list="fileList">-->
                    <!--<el-button size="small" type="primary">导入标本</el-button>-->
                  <!--</el-upload>-->
                <!--</el-form-item>-->
                <el-form-item>
                  <el-button
                    type="primary"
                    @click.native.prevent="importSampleHandle()">
                    导入标本
                  </el-button>
                </el-form-item>
              </template>
              <el-form-item>
                <el-button
                  type="primary"
                  @click.native.prevent="confirmSendSample()"
                  :disabled="dataListSelections.length <= 0">
                  确认送样
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="courierListExport">导出物流清单</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleItem(1)">单采</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleItem(10)">10人混采</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleItem(20)">20人混采</el-button>
              </el-form-item>
            </el-form>
            <el-table  class="mhide"
              :data="dataList"
              border
              v-loading="loading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;"
              :height="tableHeight">
              <el-table-column
                type="selection"
                header-align="center"
                align="center">
              </el-table-column>
              <el-table-column
                type="index"
                align="center"
                label="序号">
              </el-table-column>
              <el-table-column
                prop="orderNum"
                header-align="center"
                align="center"
                width="150"
                label="订单号">
              </el-table-column>
              <el-table-column
                prop="hospCode"
                header-align="center"
                align="center"
                label="医院条形码">
              </el-table-column>
              <el-table-column
                prop="patientName"
                header-align="center"
                align="center"
                label="姓名">
              </el-table-column>
              <el-table-column
                prop="patientSex"
                header-align="center"
                align="center"
                label="性别">
                <template slot-scope="scope">
                  <template v-for="item in options_patientSex">
                    <template v-if="scope.row.patientSex == item.value">
                      {{item.label}}
                    </template>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                prop="patientTel"
                header-align="center"
                align="center"
                label="联系电话"
                width="100">
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                label="出生日期">
                <template slot-scope="scope" v-if="scope.row.patientBirthday">
                  {{scope.row.patientBirthday.substring(0, scope.row.patientBirthday.length - 8)}}
                </template>
              </el-table-column> -->
              <el-table-column
                prop="patientAge"
                header-align="center"
                align="center"
                label="年龄">
              </el-table-column>
              <el-table-column
                prop="itemName"
                header-align="center"
                align="center"
                label="检验项目"
                width="150">
              </el-table-column>
              <el-table-column
                prop="sampleType"
                header-align="center"
                align="center"
                label="标本类型">
              </el-table-column>
              <el-table-column
                prop="sampleNum"
                header-align="center"
                align="center"
                label="标本数量">
              </el-table-column>
              <el-table-column
                prop="providerName"
                header-align="center"
                align="center"
                label="送检检验所">
              </el-table-column>
              <el-table-column
                prop="keshi"
                header-align="center"
                align="center"
                label="送检科室">
              </el-table-column>
              <el-table-column
                prop="orderStatus"
                header-align="center"
                align="center"
                label="订单确认">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.orderConfirmStatus === 0" size="small" type="warning">待确认</el-tag>
                  <el-tag v-else-if="scope.row.orderConfirmStatus === 1" size="small" type="success">已确认</el-tag>
                  <el-tag v-else-if="scope.row.orderConfirmStatus === 2" size="small" type="danger">已拒绝</el-tag>
                  <el-tag v-else size="small" type="info">暂无</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                header-align="center"
                align="center"
                label="标本状态">
                <template slot-scope="scope">
                  <template v-for="item in options_status">
                    <template v-if="scope.row.status == item.value">
                      <el-tag v-if="item.value == 0" size="small" type="info">{{item.label}}</el-tag>
                      <el-tag v-else-if="item.value == 9" size="small" type="danger">{{item.label}}</el-tag>
                      <el-tag v-else size="small" class="tag_highlight">{{item.label}}</el-tag>
                    </template>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                prop="submitTime"
                header-align="center"
                align="center"
                label="采样时间">
              </el-table-column>
              <el-table-column
                prop="sampleReceiveTime"
                header-align="center"
                align="center"
                label="收样时间">
              </el-table-column>
              <el-table-column
                prop="reportTime"
                header-align="center"
                align="center"
                label="报告时间">
              </el-table-column>
              <el-table-column
                prop="reportMode"
                header-align="center"
                align="center"
                label="报告方式">
                <template slot-scope="scope">
                  <template v-for="item in options_reportMode">
                    <template v-if="scope.row.reportMode == item.value">
                      {{item.label}}
                    </template>
                  </template>
                </template>
              </el-table-column>

              <el-table-column
                prop="result"
                header-align="center"
                align="center"
                label="检验结果">
                <template slot-scope="scope">
                  <!--<template v-for="item in options_result">-->
                    <!--<template v-if="scope.row.result == item.value">-->
                      <el-tag type="success" v-if="scope.row.result=='0'">阴性</el-tag>
                      <el-tag type="danger" v-else-if="scope.row.result=='1'">阳性</el-tag>
                      <el-tag type="info" v-else>暂无</el-tag>
                    <!--</template>-->
                  <!--</template>-->
                </template>
              </el-table-column>
              <el-table-column
                prop="refuseReceiveDesc"
                header-align="center"
                align="center"
                label="拒绝原因">
                <template slot-scope="scope">
                  <el-button type="text" size="small" v-if="scope.row.refuseReceiveDesc || scope.row.refuseReceiveFilePath" @click="refuseReceiveDetail(scope.row.refuseReceiveDesc,scope.row.refuseReceiveFilePath)">查看原因</el-button>
                  <template v-else>无</template>
                </template>
              </el-table-column>

              <el-table-column
                fixed="right"
                header-align="center"
                align="center"
                label="操作">
                <template slot-scope="scope">
                  <template v-if="user.isChannel == 2">
                    <el-button type="text" size="small" @click="toSampleUpdate(scope.row.id)" v-if="(scope.row.status === 1 || scope.row.status === 9 )&& scope.row.orderStatus <= 6">修改标本</el-button>
                    <!--<el-button type="text" size="small" @click="deleteSample(scope.row.id)" v-if="scope.row.orderStatus < 6 || scope.row.orderStatus === 13">取消标本</el-button>-->
                  </template>
                  <el-button type="text" size="small" @click="checkReport(scope.row.reportUrl)" v-if="scope.row.reportUrl" >浏览报告</el-button>
                  <template v-if="user.isChannel == 2">
                    <el-button type="text" size="small" @click="checkPaperReport(scope.row.reportUrl)" v-if="scope.row.reportUrl && scope.row.reportMode === 1">浏览纸质报告</el-button>
                    <el-button type="text" size="small" @click="downloadReport(scope.row.id)" v-if="scope.row.reportUrl">下载报告</el-button>
                    <!--<el-button type="text" size="small" @click="toSampleLogistics(scope.row.id)" v-if="scope.row.orderStatus > 5 && scope.row.orderStatus < 11">查看物流</el-button>-->
                  </template>
                </template>
              </el-table-column>
            </el-table>

            <el-table class="mshow"
              :data="dataList"
              border
              v-loading="loading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;"
              :height="tableHeight">
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="30">
              </el-table-column>
              <el-table-column
                type="index"
                align="center"
                width="50"
                label="序号">
              </el-table-column>
              <el-table-column
                prop="hospCode"
                header-align="center"
                align="center"
                label="医院条形码">
              </el-table-column>
              <el-table-column
                prop="patientName"
                header-align="center"
                align="center"
                label="姓名">
              </el-table-column>
              <el-table-column
                fixed="right"
                header-align="center"
                align="center"
                label="操作"
                width="80">
                <template slot-scope="scope">
                  <template v-if="user.isChannel == 2">
                    <el-button type="text" size="small" @click="toSampleUpdate(scope.row.id)" v-if="(scope.row.status === 1 || scope.row.status === 9 )&& scope.row.orderStatus <= 6">修改标本</el-button>
                    <!--<el-button type="text" size="small" @click="deleteSample(scope.row.id)" v-if="scope.row.orderStatus < 6 || scope.row.orderStatus === 13">取消标本</el-button>-->
                  </template>
                  <el-button type="text" size="small" @click="checkReport(scope.row.reportUrl)" v-if="scope.row.reportUrl" >浏览报告</el-button>
                  <el-button type="text" size="small" @click="checkdtal(scope.row.id)" >查看详情</el-button>
                  <template v-if="user.isChannel == 2">
                    <el-button type="text" size="small" @click="checkPaperReport(scope.row.reportUrl)" v-if="scope.row.reportUrl && scope.row.reportMode === 1">浏览纸质报告</el-button>
                    <el-button type="text" size="small" @click="downloadReport(scope.row.id)" v-if="scope.row.reportUrl">下载报告</el-button>
                    <!--<el-button type="text" size="small" @click="toSampleLogistics(scope.row.id)" v-if="scope.row.orderStatus > 5 && scope.row.orderStatus < 11">查看物流</el-button>-->
                  </template>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="dataForm.page"
              :page-size="dataForm.limit"
              :total="totalCount"
              layout="total, prev, pager, next, jumper">
            </el-pagination>
          </el-main>
        </el-container>
      </el-container>
    </div>

    <!--底部导航-->
    <tabbar class="mshow" :selected="selected" :tabs='tabs'></tabbar>

    <!--标本信息弹框-->
    <sample-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList()"></sample-add-or-update>
    <!--确认送样弹框-->
    <confirm-send-sample v-if="confirmSendSampleVisible" ref="confirmSendSample" @refreshDataList="getDataList()" :confirmList="this.datalist"></confirm-send-sample>
    <!--查看详情弹框-->
    <sample-detail v-if="SampleVisible" ref="Sample" ></sample-detail>
    <!--物流信息弹框-->
    <sample-logistics-info v-if="sampleLogisticsInfoVisible" ref="sampleLogisticsInfo"></sample-logistics-info>
    <!--拒绝原因弹框-->
    <refuse-receive-detail v-if="refuseReceiveDetailVisible" ref="refuseReceiveDetail"></refuse-receive-detail>
    <!--导入标本弹框-->
    <sample-import v-if="sampleImportVisible" ref="sampleImport" @refreshDataList="getDataList()"></sample-import>
    <!--混采弹框-->
    <sample-item v-if="sampleItemVisible" ref="sampleItem" @refreshDataList="getDataList()" @refreshMix="handleMixed(arguments)"></sample-item>
    <sample-mix v-if="sampleMixVisible" ref="sampleMix" @refreshDataList="getDataList()" @closeItem="sampleItemVisible = false"></sample-mix>
  </div>

</template>

<script>
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import NavLeft from '@/components/NavLeft.vue'
  import SampleAddOrUpdate from '../../components/sample-add-or-update-bk'
  import ConfirmSendSample from '../../components/confirm-send-sample'
  import SampleLogisticsInfo from '../../components/sample-logistics-info'
  import RefuseReceiveDetail from '../../components/refuse-receive-detail'
  import sampleDetail from '../../components/sample-detail'
  import SampleImport from '../../components/sample-import'
  import {getCookie} from "../../util/util";
  import SampleItem from "../../components/sample-item";
  import SampleMix from "../../components/sample-mix";




  export default {
    name: "sample-manage",
    data() {
      return {
        p_showSearch:true,
        p_loginModalFlag:false,
        p_showNavbar: true,
        p_activeIndex: '6',
        addOrUpdateVisible: false,
        confirmSendSampleVisible: false,
        sampleLogisticsInfoVisible: false,
        SampleVisible: false,
        refuseReceiveDetailVisible: false,
        sampleImportVisible: false,
        sampleMixVisible: false,
        sampleItemVisible: false,
        tableHeight: 0,
        loading:true,
        totalCount:0,
        dataListSelections:[],
        dataList:[],
        fileList: [],
        importSampleUrl: process.env.API_ROOT + '/jys/hospSample/import?' + `token=${getCookie("_token")}`,
        dataForm: {
          page: 1,
          limit: 10,
          orderNum: this.$route.query.orderNum?this.$route.query.orderNum:'',
          hospCode:'',
          patientName: '',
          patientTel: '',
          testStatus:'',
          providerName:'',
          itemName:'',
          result:'',
          //orderAddBt:'',
          //orderAddEt:'',
          snReceiveBt:'',
          snReceiveEt:'',
          reportBt:'',
          reportEt:''
        },
        //性别
        options_patientSex: [{
          value: '0',
          label: '女'
        }, {
          value: '1',
          label: '男'
        }],
        //标本状态
        options_status: [
        // {
        //   value: '0',
        //   label: '默认'
        // },
        {
          value: '1',
          label: '待送样'
        }, {
          value: '2',
          label: '待检验'
        }, {
          value: '3',
          label: '检验完成'
        }, {
          value: '4',
          label: '待回收'
        }, {
          value: '9',
          label: '拒收'
        }],
        //检验结果
        options_result: [{
          value: '-1',
          label: '暂无'
        }, {
          value: '0',
          label: '阴性'
        }, {
          value: '1',
          label: '阳性'
        }],
        //报告方式
        options_reportMode: [{
          value: '0',
          label: '电子'
        }, {
          value: '1',
          label: '纸质'
        }],
        //检验项目
        options_item: [],
        //送检检验所
        options_provider:[],
        //订单创建时间
        picker_orderAddBt: {
          disabledDate: time => {
            if (this.dataForm.orderAddEt) {
              return (
                time.getTime() > new Date(this.dataForm.orderAddEt).getTime()
              )
            }
          }
        },
        picker_orderAddEt: {
          disabledDate: time => {
            if (this.dataForm.orderAddBt) {
              return (
                time.getTime() < new Date(this.dataForm.orderAddBt).getTime()
              )
            }
          }
        },
        //收样时间
        picker_snReceiveBt: {
          disabledDate: time => {
            if (this.dataForm.snReceiveEt) {
              return (
                time.getTime() > new Date(this.dataForm.snReceiveEt).getTime()
              )
            }
          }
        },
        picker_snReceiveEt: {
          disabledDate: time => {
            if (this.dataForm.snReceiveBt) {
              return (
                time.getTime() < new Date(this.dataForm.snReceiveBt).getTime()
              )
            }
          }
        },
        //报告时间
        picker_reportBt: {
          disabledDate: time => {
            if (this.dataForm.reportEt) {
              return (
                time.getTime() > new Date(this.dataForm.reportEt).getTime()
              )
            }
          }
        },
        picker_reportEt: {
          disabledDate: time => {
            if (this.dataForm.reportBt) {
              return (
                time.getTime() < new Date(this.dataForm.reportBt).getTime()
              )
            }
          }
        },
        selected: '',
        tabs: [
          require("@/assets/hose_Filled.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_grey.png")
        ]
      }
    },
    components: {
      SampleMix,
      SampleItem,
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
      NavLeft,
      SampleAddOrUpdate,
      ConfirmSendSample,
      SampleLogisticsInfo,
      RefuseReceiveDetail,
      sampleDetail,
      SampleImport
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    mounted () {
      if (getCookie("_token")) {
        this.getProviderAss()
        this.getDataList()
        setTimeout(() => {
          this.tableHeight = document.documentElement.clientHeight - 300
        }, 100)
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {

      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },
      handleFocus(e) {
        setTimeout(function() {
          e.target.scrollIntoView(true);
          e.target.scrollViewIfNeeded()
        }, 200)
      },



      //获取检验所
      getProviderAss () {
        axios.get('/jys/provider/ass'
        ).then(res => {
          if (res.data.code == 0) {
            this.options_provider = res.data.list
          }
        })
      },

      //获取医疗机构样本
      getDataList (flag) {
        if (flag === 0) {
          this.dataForm.page = 1
        }
        this.loading = true
        axios.get("/jys/sample/hospList",{
          params:this.dataForm
        }).then((res) => {
          if(res.data.code == 0){
            this.loading = false
            this.dataList = res.data.page.list
            this.totalCount =  res.data.page.totalCount
          }
        })
      },

      //选择检验所-获取检验项目
      selectProvider(e){
        this.dataForm.providerName = e.providerName
        axios.get("/jys/item/pvdItem/" + e.id + "/3"
        ).then((res) => {
          if(res.data.code == 0){
            this.options_item = res.data.list
          }
        })
      },

      //多选
      selectionChangeHandle (val) {
        this.dataListSelections = []
        for (let i=0; i<val.length; i++) {
          this.dataListSelections.push(val[i].id)
        }
      },

      handleCurrentChange (val) {
        this.dataForm.page = val
        this.getDataList()
      },

      //录入标本
      addOrUpdateHandle () {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init('')
        })
      },

      //导入标本
      importSampleHandle () {
        this.sampleImportVisible = true
        this.$nextTick(() => {
          this.$refs.sampleImport.init()
        })
      },

      //修改标本
      toSampleUpdate (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      checkdtal (id) {
        this.SampleVisible = true;

          this.$refs.Sample.init(id)

      },

      //取消标本 id:标本ID
      deleteSample (id) {
        this.$confirm('确定进行[取消]操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.post('/jys/hospSample/cancel/' + id
          ).then((res) => {
            if(res.data.code == 0){
              this.$alert('取消标本信息成功', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  this.getDataList()
                }
              });
            }
          })
        }).catch((error) => {
          console.log(error)
        });
      },

      //浏览报告
      checkReport (url) {
        window.open(url + '?t=' + new Date().getTime())
      },

      //浏览纸质报告
      checkPaperReport (url) {
        let index = url.lastIndexOf('.')
        window.open(url.substring(0, index) + '_A3.pdf?t=' + new Date().getTime())
      },

      //批量下载报告 id:标本id
      downloadReport (id) {
        let url = process.env.API_ROOT + '/jys/sample/downloadReport?'
        let ids = id ? [id] : this.dataListSelections

        // for (let key in this.dataForm) {
        //   if (!this.dataForm.hasOwnProperty(key)) continue
        //   url += `${key}=${this.dataForm[key]}&`
        // }

        let temp = ''
        if(ids.length){
          temp = '['
          for (let i=0; i<ids.length; i++) {
            temp = temp + ids[i] + ','
          }
          temp = temp + ']'
        }

        this.$confirm('确定进行[下载]操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //检查所选标本是否存在报告
          this.dataForm.ids = temp
          axios.get("/jys/sample/checkReport", {
            params: this.dataForm
          }).then((res) => {
            if (res.data.code == 0) {
              location.href = url + 'ids=' + temp + `&token=${getCookie("_token")}`
            }
          })
        }).catch((error) => {
          console.log(error)
        });
      },

      //导出标本
      exportExcel () {
        let url = process.env.API_ROOT + '/jys/sample/exportHospList?'
        let ids = this.dataListSelections

        for (let key in this.dataForm) {
          if (!this.dataForm.hasOwnProperty(key)) continue
          url += `${key}=${this.dataForm[key]}&`
        }

        if(ids.length){
          let temp = 'ids=['
          for (let i=0; i<ids.length; i++) {
            temp = temp + ids[i] + ','
          }
          temp = temp + ']'

          location.href = url + temp + `&token=${getCookie("_token")}`
        }else{
          location.href = url.substring(0, url.length - 1) + `&token=${getCookie("_token")}`
        }
      },

      //导出物流清单
      courierListExport() {
        let url = process.env.API_ROOT + '/jys/hospSample/courierListExport?'
        let ids = this.dataListSelections

        for (let key in this.dataForm) {
          if (!this.dataForm.hasOwnProperty(key)) continue
          url += `${key}=${this.dataForm[key]}&`
        }

        if (ids.length) {
          let temp = 'ids=['
          for (let i = 0; i < ids.length; i++) {
            temp = temp + ids[i] + ','
          }
          temp = temp + ']'

          location.href = url + temp + `&token=${getCookie("_token")}`
        } else {
          location.href = url.substring(0, url.length - 1) + `&token=${getCookie("_token")}`
        }
      },

      //下载模板
      downloadTemplate () {
        let url = 'https://pic.jianyanwang.com/upload/20200828/3a500229112e40dc8d64e3fceaf40623.xlsx'
        window.open(url + '?t=' + new Date().getTime())
      },

      //导入标本
      beforeUploadHandle (file) {
        this.loading = true
      },
      successHandle (response, file, fileList) {
        this.loading = false
        this.fileList = fileList
        if (response && response.code === 0) {
          this.$alert('导入标本信息成功', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              this.getDataList()
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: response.msg
          });
        }
        this.fileList = []
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },

      //确认送样
      confirmSendSample (id) {
        let ids = id ? [id] : this.dataListSelections
        this.confirmSendSampleVisible = true
        // this.$nextTick(() => {
        //   this.$refs.confirmSendSample.init(ids)
        //   // this.$refs.confirmSendSample.dataList = this.dataList
        // })
        let confirmText = `对所选报告已进行确认送样操作`
        // this.$confirm(confirmText, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$http({
        //     url: this.$http.adornUrl('/jys/hospSample/confirmSendSample'),
        //     method: 'post',
        //     data: this.$http.adornData(ids, false)
        //   }).then(({data}) => {
        //     console.log('data', data)
        //     if (data && data.code === 0) {
        //       this.getProviderAss()
        //       this.getDataList()
        //     } else {
        //       this.$message.error(data.msg)
        //     }
        //   })
        // })
        axios.post("/jys/hospSample/confirmSendSample",{
          'ids': JSON.stringify(ids),
          // 'sendSampleFilePath': this.dataForm.filePath
        }).then((res) => {
          if(res.data.code == 0){
            this.$message({
              message: confirmText,
              type: 'success',
              duration: 3000,
              // onClose: () => {
                // this.visible = false
                // this.$emit('refreshDataList')
              // }
            })
            this.getProviderAss()
            this.getDataList()
          }
        })
      },

      //查看物流
      toSampleLogistics (id) {
        this.sampleLogisticsInfoVisible = true
        this.$nextTick(() => {
          this.$refs.sampleLogisticsInfo.init(id)
        })
      },

      //查看拒绝原因
      refuseReceiveDetail (refuseReceiveDesc, refuseReceiveFilePath) {
        this.refuseReceiveDetailVisible = true
        this.$nextTick(() => {
          this.$refs.refuseReceiveDetail.init(refuseReceiveDesc, refuseReceiveFilePath)
        })
      },

      // 混采
      handleMixed (msg) {
        this.sampleMixVisible = true
        this.$nextTick(() => {
          this.$refs.sampleMix.init(msg[0], msg[1])
        })
      },

      handleItem (num) {
        this.sampleItemVisible = true
        this.$nextTick(() => {
          this.$refs.sampleItem.init(num)
        })
      }
    }
  }
</script>

<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    max-width: 200px;
  }
  .el-button + .el-button{
    margin-left: 0;
  }
  .tag_highlight {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
/*  /deep/ .el-input__inner{
    !*padding: 15px;*!
    !*height: 15px;*!
    line-height: normal;
  }*/
   /deep/ .el-loading-mask {
    position: absolute;
    z-index: 4;
    }
   .mshow{
     display: none;
   }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .userInfo {
      height: 80px;
      margin: 0;
    }
    .mshow{
      display: block;
    }
    #SampleManage{
      margin-bottom: 55px;
    }
    /deep/ .el-dialog {
      width: 98%!important;
      margin: 30px auto 400px;-webkit-overflow-scrolling: touch;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }

    /deep/ .el-row {
      display: flex;
      flex-flow: column;
    }

    /deep/ .el-col-12 {
      width: 100%;
    }

    /deep/ .el-date-editor.el-input {
      width: 100%;
    }

    /deep/ .el-input--small {
      font-size: 14px;
    }
    /deep/ .el-pagination__total{
      display: none!important;
    }
    /deep/ .el-container{
      margin-left: 0!important;
    }
    /deep/ .el-pagination button {
      min-width: initial;
    }
    /deep/ .el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/ .el-pagination{
      margin-left: 0px;
      margin-top: 10px;
    }
    /deep/ .el-pagination .btn-next {
      padding-left: 0;
    }
    /deep/ .el-pagination__jump {
      margin-left: 0;
    }
    /deep/ .el-pager li {
      min-width: 32px;
    }
    /deep/ .el-message-box{
      width: 98%!important;
    }
    .mhide{
      display: none;
    }

    *:not(input,textarea) {
   -webkit-touch-callout: none;
   -webkit-user-select: none;
}
    /deep/ .el-table--border th:first-child .cell,/deep/  .el-table--border td:first-child .cell{
      padding-left: 7px!important;
    }
    .el-dialog__wrapper {
    -webkit-overflow-scrolling: touch;
    }
    /deep/ .el-upload-dragger{

      width: 275px;
    }
    /deep/ .v-modal{
      opacity: 1!important;
      -webkit-overflow-scrolling: touch;

    }
    /deep/ .el-form-item .el-input.is-disabled .el-input__inner{
      color: #000!important;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }

    .mhide{
        display: none;}
      /deep/  .el-input--small .el-input__inner{
          padding:0;line-height:normal;-webkit-touch-callout: none;
          -webkit-text-size-adjust: none;-webkit-user-select: auto!important;-moz-user-select: auto!important;-ms-user-select: auto!important;user-select: auto!important;
          -webkit-transform: translate3d(0, 0, 0);

      }
      /deep/  .el-input--small .el-input__inner{padding-left:0;text-indent:10px}


    /deep/ .el-button--primary.is-disabled {
      color: #ffffff;
      background-color: #c0c4cc;
      border-color: #c0c4cc;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/sample/sample-manage.vue